import {
  GOOGLE_API_SERVICES as links_GOOGLE_API_SERVICES,
  PRIVACY_POLICY as links_PRIVACY_POLICY,
  SUPPORT as links_SUPPORT,
  TERMS_OF_SERVICE as links_TERMS_OF_SERVICE,
} from '../../constants/accountRecoveryLinks'
import {
  FOOTER_LICENSE,
  GOOGLE_API_SERVICES,
  PRIVACY_POLICY,
  SUPPORT,
  TERMS_OF_SERVICE,
} from '../../constants/ui.labels'
import Flex from '@talkdesk/cobalt-react-flex'
import Link from '@talkdesk/cobalt-react-link'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const AccountRecoveryFooter = ({ showGoogleFooterLink }) => {
  const theme = useTheme()

  return (
    <Flex
      as='footer'
      alignX='center'
      paddingX={[3, 3, 4]}
      paddingY='3'
      backgroundColor={theme.gray100}
      width='100%'
    >
      <Flex gap='5'>
        <Text inline color={theme.gray600} size='small'>
          {FOOTER_LICENSE}
        </Text>
        <Link target='_blank' href={links_SUPPORT}>
          <Text inline color={theme.gray600} size='small'>
            {SUPPORT}
          </Text>
        </Link>
        <Link target='_blank' href={links_TERMS_OF_SERVICE}>
          <Text inline color={theme.gray600} size='small'>
            {TERMS_OF_SERVICE}
          </Text>
        </Link>
        <Link target='_blank' href={links_PRIVACY_POLICY}>
          <Text inline color={theme.gray600} size='small'>
            {PRIVACY_POLICY}
          </Text>
        </Link>
        {showGoogleFooterLink && (
          <Link target='_blank' href={links_GOOGLE_API_SERVICES}>
            <Text inline color={theme.gray600} size='small'>
              {GOOGLE_API_SERVICES}
            </Text>
          </Link>
        )}
      </Flex>
    </Flex>
  )
}

export default AccountRecoveryFooter
